import { mapProductListItemToProductMM } from "./mapProductListItemToProductMM";
import type { IOffer as IOfferApi } from "~/shared/api/ke-gateway/product/models";
import type { IOffer } from "../model/IOffer";

export function mapProductCompilationsToProductMM(productCompilations: IOfferApi[]): IOffer[] {
  return productCompilations.map((productCompilation) => {
    return {
      title: productCompilation.title,
      categoryId: productCompilation.categoryId,
      offerDto: productCompilation.offerDto,
      productList: productCompilation.productList.map(mapProductListItemToProductMM),
    }
  });
}